export const FIND_TAGS_FAILURE = 'FIND_TAGS_FAILURE';

export const findTagsFailure = ( payload: Error ) => ({
    type: FIND_TAGS_FAILURE,
    payload,
});